import { useUser } from '~/api/hooks/useGetAccount';
import { useGetForecastGraph } from '~/api/hooks/useGetForecastGraph';
import { useRegion } from '~/features/region/hooks/useRegion';

export const useForecastGraph = () => {
  const { data: user } = useUser();
  const { regionCode } = useRegion();
  const { data } = useGetForecastGraph({
    child_id: user?.selected_child_id,
    regionCode: regionCode,
  });

  return { data };
};
